import axios from 'axios';
import humps from 'humps';
import {
  LAB_RESULTS_API_URL,
  APPOINTMENT_AUTH_API_URL,
  IAM_API_URL,
  CONSULT_API_URL,
  MARKETPLACE_API_URL,
  HEALTH_SUMMARY_API_URL,
  SEARCH_API_URL,
  FILE_API_URL,
  EMC_API_URL,
  ACCOUNT_MANAGEMENT_API_URL,
  EMR_API_URL,
  PRESCRIPTION_API_URL,
  ALERT_API_URL,
  NOTIFICATION_API_URL,
  INVOICE_API_URL,
  REPORT_API_URL,
  MANAPAY_API_URL,
  AI_API_URL,
} from 'Constants/apis';
import {
  API_EMC,
  API_FILE,
  API_CONSULT,
  API_EMR,
  API_PRESCRIPTION,
  API_HEALTH_SUMMARY,
  API_APPOINTMENT,
  API_LAB,
  API_ALERT,
  API_NOTIFICATION,
  API_SEARCH,
  API_INVOICE,
  API_REPORT,
  API_MANAPAY,
  API_IAM,
  API_MARKETPLACE,
  API_ACCOUNT_MANAGEMENT,
  API_AI,
} from 'Constants/client-modules';

const CONTENT_TYPE_FORM_DATA = 'CONTENT_TYPE_FORM_DATA';
const CONTENT_TYPE_JSON = 'CONTENT_TYPE_JSON';

export const initClient = (baseURL, options = {}) => {
  const { type = CONTENT_TYPE_JSON, headers = {}, isDecamelizeKeys = true } = options;

  const defaultHeaders =
    type === CONTENT_TYPE_FORM_DATA
      ? {
          'Content-Type': 'multipart/form-data',
        }
      : {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          'Cache-Control': 'no-cache',
          // 'Cross-Origin-Embedder-Policy': 'require-corp',
          // 'Cross-Origin-Opener-Policy': 'same-origin',
          'App-Version': process.env.APP_VERSION || 'dev',
        };

  const defaultTransformRequest =
    type === CONTENT_TYPE_FORM_DATA
      ? []
      : [
          data =>
            isDecamelizeKeys && !data?.notTransformRequest
              ? JSON.stringify(humps.decamelizeKeys(data))
              : JSON.stringify(data),
        ];

  const instance = axios.create({
    baseURL,
    headers: {
      ...defaultHeaders,
      ...headers,
    },
    transformRequest: defaultTransformRequest,
    transformResponse: [
      data => {
        if (data) {
          try {
            return humps.camelizeKeys(JSON.parse(data));
          } catch (error) {
            throw new SyntaxError('Something went wrong - Error code: 600');
          }
        }
        return data;
      },
    ],
  });

  let token;

  instance.setJwtToken = newToken => {
    token = newToken;
  };

  instance.interceptors.request.use(
    conf => {
      return {
        ...conf,
        headers: {
          ...conf.headers,
          Authorization: token,
        },
        params: isDecamelizeKeys ? humps.decamelizeKeys(conf.params) : conf.params,
      };
    },
    error => Promise.reject(error),
  );

  instance.interceptors.response.use(
    response => response.data,
    error => Promise.reject(error.response ? error.response.data : error),
  );
  return instance;
};

const labResultsIntance = initClient(LAB_RESULTS_API_URL);
const consultInstance = initClient(CONSULT_API_URL);
const marketplaceInstance = initClient(MARKETPLACE_API_URL);
const healthSummaryInstance = initClient(HEALTH_SUMMARY_API_URL);
const fileInstance = initClient(FILE_API_URL, { type: CONTENT_TYPE_FORM_DATA });
const emcInstance = initClient(EMC_API_URL);
const prescriptionInstance = initClient(PRESCRIPTION_API_URL);
const searchInstance = initClient(SEARCH_API_URL);
const accountManagementInstance = initClient(ACCOUNT_MANAGEMENT_API_URL);
const appointmentInstance = initClient(APPOINTMENT_AUTH_API_URL);
const iamInstance = initClient(IAM_API_URL);
const emrInstance = initClient(EMR_API_URL, { isDecamelizeKeys: false });
const alertInstance = initClient(ALERT_API_URL);
const notificationInstance = initClient(NOTIFICATION_API_URL);
const invoiceInstance = initClient(INVOICE_API_URL);
const reportInstance = initClient(REPORT_API_URL);
const manapayInstance = initClient(MANAPAY_API_URL);
const aiInstance = initClient(AI_API_URL);

const clients = {
  [API_LAB]: labResultsIntance,
  [API_APPOINTMENT]: appointmentInstance,
  [API_IAM]: iamInstance,
  [API_CONSULT]: consultInstance,
  [API_HEALTH_SUMMARY]: healthSummaryInstance,
  [API_FILE]: fileInstance,
  [API_EMC]: emcInstance,
  [API_SEARCH]: searchInstance,
  [API_ACCOUNT_MANAGEMENT]: accountManagementInstance,
  [API_EMR]: emrInstance,
  [API_PRESCRIPTION]: prescriptionInstance,
  [API_ALERT]: alertInstance,
  [API_NOTIFICATION]: notificationInstance,
  [API_INVOICE]: invoiceInstance,
  [API_REPORT]: reportInstance,
  [API_MANAPAY]: manapayInstance,
  [API_MARKETPLACE]: marketplaceInstance,
  [API_AI]: aiInstance,
};

export default clients;
